import { Route, Routes } from "react-router-dom";
import Admindashboard from "./Admindashboard";
import AddMA from "./adminmanagement/AddMA";
import Collaborations from "./Collaborations";
import ComapnyUsers from "./ComapnyUsers";
import CompanyCreditPassBook from "./CompanyCreditPassBook";
import CompanyCreditsManagement from "./CompanyCreditsManagement";
import ContactMessages from "./ContactMessages";
import CreditPassBook from "./CreditPassBook";
import Credits from "./Credits";
import UpgradeCredits from "./credits/UpgradeCredits";
import AdminLayout from "./layout/AdminLayout";
import Logout from "./Logout";
import Settings from "./Settings";
import UserManagemnet from "./UserManagemnet";
import UsersList from "./UsersList";

const AdminDashboardRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminLayout />}>
        <Route index element={<Admindashboard />} />
        <Route path="/credit" element={<Credits />} />
        <Route path="/user-management/add-admin" element={<AddMA />} />
        <Route path="/credit-management" element={<UserManagemnet />} />
        <Route
          path="/company-management"
          element={<CompanyCreditsManagement />}
        />
        <Route path="/settings" element={<Settings />} />
        <Route path="/logout" element={<Logout />} />

        <Route
          path="/credit-management/credit-passbook"
          element={<CreditPassBook />}
        />
        <Route
          path="/company-management/credit-passbook"
          element={<CompanyCreditPassBook />}
        />
        <Route
          path="company-management/users-list"
          element={<ComapnyUsers />}
        />
         <Route
          path="collaborations"
          element={<Collaborations />}
        />

        <Route path="contact-messages" element={<ContactMessages />} />
        <Route path="upgrade-credits" element={<UpgradeCredits />} />

        <Route path="user-management" element={<UsersList />} />
      </Route>
      
    </Routes>
  );
};

export default AdminDashboardRoute;
